module.exports = __webpack_public_path__ + "media/images/tailwind/twitter-63d010adb7cd3354173784ce32f33516.png";